
import React from 'react';
import { ShakeOnHover } from '../../../components/feature/MicroInteractions';

const Hero = () => {
  const scrollToFinalCTA = () => {
    const element = document.getElementById('final-cta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openReadyAgent = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(52, 68, 75, 0.4), rgba(52, 68, 75, 0.4)), url('https://public.readdy.ai/ai/img_res/d88b70d7f178f67e1106897fb6ccbadf.jpg')`
      }}
    >
      <div className="w-full px-6 py-20 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="max-w-3xl">
            <ShakeOnHover>
              <h1 className="text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
                You built something <span className="text-[#A8AE9C]">great</span>.
                <br />
                Now let's make sure the <span className="text-[#A8AE9C]">right people</span> find it.
              </h1>
            </ShakeOnHover>
            
            <p className="text-xl lg:text-2xl mb-12 text-gray-200 leading-relaxed">
              Your customers love you. Your product works. But somehow, the people who need you most can't find you. 
              <strong className="text-white"> That's not a business problem—that's a words problem.</strong>
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 mb-16">
              <button 
                onClick={scrollToFinalCTA}
                className="bg-[#708474] text-white px-10 py-5 rounded-lg text-xl font-semibold hover:bg-[#73807c] transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Let's Talk About Your Legacy
              </button>
              <button 
                onClick={openReadyAgent}
                className="border-2 border-white text-white px-10 py-5 rounded-lg text-xl font-semibold hover:bg-white hover:text-[#34444b] transition-all duration-300 cursor-pointer whitespace-nowrap group"
              >
                <span className="flex items-center justify-center">
                  <i className="ri-chat-3-line mr-3 group-hover:animate-bounce w-6 h-6 flex items-center justify-center"></i>
                  Talk to Someone Who Gets It
                </span>
              </button>
            </div>

            <div className="text-gray-300 text-lg">
              <span className="opacity-75">First call is free. No pitch. Just honesty.</span>
            </div>
          </div>
        </div>
      </div>

      {/* Simple scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
